import { useTheme } from '@mui/material/styles';

interface LineEndLabelProps {
  x?: number;
  y?: number;
  value?: string;
}

const CHAR_WIDTH = 6.4;
const PADDING_X = 8;
const HEIGHT = 22;

export const GAP_FROM_LINE = 8;

export const getEndLabelWidth = (value: string) => value.length * CHAR_WIDTH + PADDING_X * 2;

const LineEndLabel = ({ x, y, value }: LineEndLabelProps) => {
  const { palette, shape, typography } = useTheme();

  if (x === undefined || y === undefined || !value) {
    return null;
  }

  const width = getEndLabelWidth(value);

  return (
    <g>
      <rect
        x={x + GAP_FROM_LINE}
        y={y - HEIGHT / 2}
        width={width}
        height={HEIGHT}
        rx={shape.borderRadiusFull}
        fill={palette.background.paper}
        stroke={palette.divider}
      />
      <text
        x={x + GAP_FROM_LINE + width / 2}
        y={y}
        textAnchor="middle"
        dominantBaseline="central"
        fontSize={typography.micro1.fontSize}
        fill={palette.text.primary}
      >
        {value}
      </text>
    </g>
  );
};

export default LineEndLabel;
